const section = {
    about: '私について',
    projects: 'プロジェクト',
    blogs: 'ブログ',
    skills: 'スキル',
    contact: 'お問い合わせ 🤙',
    projectDetails: '詳細',
    seeMoreGithub: 'GitHubでもっと見る',
    moreArticle: 'もっと記事を見る',
    downloadResume: '履歴書をダウンロード',
};

export default section;
